<template>
  <div class="app">
    <h1>财务助手小程序介绍页</h1>
    <Header :activeIndex="'1-4'" />

    <main class="finance-page">
      <section class="section-shell intro-section">
        <div class="intro-grid">
          <div class="intro-visual">
            <img loading="lazy" src="../assets/img/xcx_zy.jpg" alt="财务助手小程序主图" class="intro-img">
          </div>
          <div class="intro-content">
            <div class="intro-card">
              <h2>功能全面 工作实用</h2>
              <p>聚合税费计算、退休年龄计算、公司起名、在线合同、发票抬头、电子名片等高频功能，帮助企业客户在注册筹备、财税辅助、资料使用和日常经营中获得更完整的线上支持。</p>
            </div>
            <div class="intro-card">
              <h2>企业发展的得力助手</h2>
              <p>通过实用财务服务、创业指导、公司制度设计、IT系统建设与研发等模块，为企业客户提供更丰富的服务入口，让业务咨询、功能了解和需求对接更加高效便捷。</p>
            </div>
            <div class="intro-card">
              <h2>多方位支持 操作便捷</h2>
              <p>手机上一键能生成合同并且下载，结合我的店铺、待办事项等功能，小程序可帮助客户集中管理常用内容和重点事务，减少信息分散带来的沟通成本，让日常使用更加清晰顺畅。</p>
            </div>
            <div class="hotline">
              服务热线：<a href="tel:13910303798">1391 0303 798</a>
            </div>
          </div>
        </div>
      </section>

      <section class="section-shell">
        <div class="section-heading">
          <h2 class="section-tag">适用客户群体</h2>
        </div>
        <div class="audience-grid">
          <article v-for="group in audienceList" :key="group.title" class="info-card">
            <div class="card-header">
              <div class="icon-placeholder"><i :class="group.iconClass"></i></div>
              <h3>{{ group.title }}</h3>
            </div>
            <div class="divider"></div>
            <p>{{ group.description }}</p>
          </article>
        </div>
      </section>

      <section class="section-shell">
        <div class="section-heading">
          <h2 class="section-tag">产品优势</h2>
        </div>
        <div class="advantage-grid">
          <article v-for="(advantage, index) in advantageList" :key="advantage.title" class="info-card advantage-card">
            <div class="card-header advantage-card-head">
              <div class="advantage-title-left">
                <div class="icon-placeholder"><i :class="advantage.iconClass"></i></div>
                <h3>{{ advantage.title }}</h3>
              </div>
              <span class="advantage-no">{{ index + 1 < 10 ? '0' + (index + 1) : index + 1 }}</span>
            </div>
            <div class="advantage-card-body">
              <p>{{ advantage.description }}</p>
            </div>
          </article>
        </div>
      </section>

      <section class="section-shell faq-section">
        <div class="section-heading">
          <h2 class="section-tag">服务案例</h2>
        </div>
        <div class="case-grid">
          <article v-for="item in caseList" :key="item.title" class="case-card">
            <div class="case-side-title">
              <h3>
                <span v-if="getTitleParts(item.title).english" class="case-title-en">
                  {{ getTitleParts(item.title).english }}
                </span>
                <span
                  v-for="(char, charIndex) in splitTitleChars(getTitleParts(item.title).chinese)"
                  :key="charIndex"
                  class="case-title-char"
                >
                  {{ char }}
                </span>
              </h3>
            </div>
            <div class="case-content">
              <p><strong>案例：</strong>{{ item.customerType }}</p>
              <p><strong>使用场景：</strong>{{ item.problem }}</p>
              <p><strong>使用效果：</strong>{{ item.result }}</p>
            </div>
          </article>
        </div>
      </section>
    </main>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'caiwuzhushou',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      audienceList: [
        {
          iconClass: 'el-icon-s-promotion',
          title: '初创企业',
          description: '名企财务助手为初创企业提供了公司起名的功能，提供了创业指导服务，为创业企业提供了公司设立前期需要的实用功能。'
        },
        {
          iconClass: 'el-icon-s-tools',
          title: '中小微企业',
          description: '名企财务助手的电子名片功能、税费计算、发票抬头管理功能、公司制度设计服务，为中小微企业在经营过程中提供了实用的运营工具。'
        },
        {
          iconClass: 'el-icon-office-building',
          title: '大型企业、国有企业',
          description: '大型企业的合同较多，人员较多，名企财务助手提供的合同生成功能和退休年龄计算器，为大型企业的合同撰写和人员管理提供了便利。'
        },
        {
          iconClass: 'el-icon-user',
          title: '老板个人',
          description: '名企财务助手的店铺搭建功能、创业指导服务，为个人经营者开设公司、产品推介和经营发展业务提供了有利条件。'
        }
      ],
      advantageList: [
        {
          iconClass: 'el-icon-s-platform',
          title: '服务入口更集中',
          description: '将财税工具、常用功能与服务资源统一整合到一个小程序中，减少多平台查找和重复沟通，让企业客户使用更加方便。'
        },
        {
          iconClass: 'el-icon-s-operation',
          title: '常用功能更实用',
          description: '涵盖税费计算、退休年龄计算、公司起名、在线合同、发票抬头、电子名片等高频功能，能够满足企业日常经营中的多种实际需求。'
        },
        {
          iconClass: 'el-icon-time',
          title: '办事效率更高',
          description: '通过待办事项、创业指导、实用财务服务等功能，帮助客户更清晰地梳理事项、提升处理效率，减少遗漏和反复确认。'
        },
        {
          iconClass: 'el-icon-s-grid',
          title: '服务内容更丰富',
          description: '集成税费计算、退休年龄计算、公司起名、在线合同、发票抬头、电子名片等多项功能，覆盖企业经营中的多种常见使用场景。'
        }
      ],
      caseList: [
        {
          title: '税费计算器',
          customerType: '新办企业快速测算经营成本',
          problem: '一家企业刚完成注册，在正式开展业务前需要大致了解税费支出情况。企业负责人对不同经营规模下可能产生的税费缺乏清晰概念，难以提前做好预算安排。',
          result: '通过税费计算器，客户能够快速进行基础测算，更直观地了解税费成本范围，为后续财务规划和经营决策提供参考。'
        },
        {
          title: '退休年龄计算器',
          customerType: '企业提前掌握员工退休节点',
          problem: '企业人事负责人在整理员工档案时，需要提前了解部分员工的退休时间。人工核对退休时间容易出错，也不方便在短时间内完成多人信息判断。',
          result: '借助退休年龄计算器，可快速获取对应参考结果，帮助企业更高效地安排人员管理和后续事务准备。'
        },
        {
          title: '公司起名',
          customerType: '创业初期提高企业命名效率',
          problem: '创业者准备注册公司时，希望先筛选几个合适的公司名称方向。对命名缺乏思路，容易在名称准备阶段反复修改，影响注册效率。',
          result: '通过公司起名功能，客户可以更快形成多个命名参考方案，提升前期准备效率，为后续注册办理节省时间。'
        },
        {
          title: '在线合同',
          customerType: '合作前快速确认基础协议内容',
          problem: '企业在与合作方开展初步业务合作前，需要准备一份基础协议文本。临时整理合同内容效率低，容易遗漏关键信息，也不便于快速确认合作条款。',
          result: '借助在线合同功能，客户能够更便捷地查看和整理常见合同内容，提高基础文本准备效率，减少前期沟通成本。'
        },
        {
          title: '发票抬头',
          customerType: '开票信息统一保存与快速调用',
          problem: '企业客户在日常合作中经常需要向不同供应商提供开票信息。发票抬头内容反复发送，容易出错或遗漏，影响日常对接效率。',
          result: '通过发票抬头功能，客户可统一查看和使用常见开票信息，减少重复沟通，提高财务资料传递的准确性和便捷度。'
        },
        {
          title: '电子名片',
          customerType: '对外展示企业信息更方便',
          problem: '企业负责人在线上沟通和业务拓展过程中，需要快速展示企业基础信息和联系方式。传统名片传播效率有限，线上场景下企业介绍不够集中，不方便快速发送。',
          result: '使用电子名片功能后，客户可以更便捷地展示企业名称、主营业务、联系方式等信息，提升对外沟通效率和企业形象展示效果。'
        },
        {
          title: '我的店铺',
          customerType: '集中展示企业服务与基础资料',
          problem: '企业希望对外统一展示自身业务内容、联系方式及相关服务信息。信息分散在多个渠道中，对外展示不集中，客户查看和了解不够方便。',
          result: '借助我的店铺功能，企业可以更集中地展示基础信息和服务内容，让客户获取信息更加直观，也有助于提升日常使用体验。'
        },
        {
          title: '实用财务服务',
          customerType: '快速找到对应财税服务入口',
          problem: '企业客户在经营过程中，临时需要了解代理记账、税务处理、工商变更等相关服务内容。往往不知道从哪里开始咨询，服务入口分散，容易增加沟通成本。',
          result: '通过实用财务服务功能，客户可以更快找到对应服务方向，提升信息获取效率，为后续咨询和办理提供更清晰的入口。'
        },
        {
          title: '创业指导',
          customerType: '帮助创业者梳理早期准备事项',
          problem: '创业者在公司注册前后，对经营准备、基础事项和服务选择还不够熟悉。创业初期信息来源杂乱，往往不知道哪些事项需要优先处理。',
          result: '借助创业指导功能，客户可以更有条理地了解创业阶段常见问题和准备方向，减少摸索时间，提高前期筹备效率。'
        },
        {
          title: 'IT设计与研发',
          customerType: '为企业数字化需求提供辅助入口',
          problem: '一家成长型企业在经营过程中，希望同步推进官网、小程序或相关数字化建设。虽然有相关需求，但缺少统一入口去了解设计与研发支持内容。',
          result: '通过IT设计与研发功能，客户可以快速了解相关服务方向，为企业后续数字化建设和技术需求对接提供更便捷的入口。'
        },
        {
          title: '制度设计与培训',
          customerType: '企业规范化管理需求快速触达',
          problem: '企业在团队逐步扩大后，希望完善内部制度并提升员工执行效率。对制度建设和培训安排缺少清晰思路，难以及时找到适合的支持方向。',
          result: '借助制度设计与培训功能，企业可以更方便地了解相关服务内容，帮助管理工作向更规范、更系统的方向推进。'
        },
        {
          title: '待办事项',
          customerType: '重点事务统一整理与持续跟进',
          problem: '企业在办理注册、财税、人事等事项期间，往往同时存在多个待处理任务。事项多而分散，容易遗漏关键节点，也不方便统一查看进展。',
          result: '使用待办事项功能后，客户能够更集中地整理和查看当前重点事务，让日常跟进更清晰，减少遗漏和反复确认。'
        }
      ]
    }
  },
  methods: {
    getTitleParts (title) {
      const match = title.match(/^([A-Za-z]+)(.*)$/)
      if (match) {
        return {
          english: match[1],
          chinese: match[2]
        }
      }
      return {
        english: '',
        chinese: title
      }
    },
    splitTitleChars (text) {
      return text ? text.split('') : []
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$root.showData.showData = false
  }
}
</script>

<style scoped>
h1 {
  font-size: 0;
}

.finance-page {
  margin-top: 96px;
  background: #fff;
  color: #333;
  padding-top: 24px;
  padding-bottom: 18px;
}

.section-shell {
  width: calc(100% - 180px);
  max-width: 1070px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 24px;
}

.section-tag {
  color: #b30101;
  font-weight: 700;
  letter-spacing: 0.5px;
  font-size: 29px;
  margin-bottom: 4px;
  text-align: center;
}

.intro-card p,
.info-card p,
.case-card p {
  line-height: 1.8;
  font-size: 15px;
  color: #555;
}

.section-heading {
  text-align: center;
  margin-bottom: 16px;
}

.section-heading h2 {
  margin: 0;
  font-size: 26px;
  line-height: 1.4;
  color: #222;
  font-weight: 700;
}

.intro-section,
.gallery-section,
.faq-section {
  padding: 18px 22px;
  border-radius: 4px;
  background: transparent;
  border: 1px solid #f0f0f0;
}

.intro-grid,
.audience-grid,
.advantage-grid,
.case-grid {
  display: grid;
  gap: 14px;
}

.audience-grid {
  align-items: start;
}

.intro-grid {
  grid-template-columns: minmax(340px, 0.9fr) minmax(0, 1.1fr);
  align-items: stretch;
  column-gap: 24px;
}

.intro-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
}

.intro-card,
.info-card,
.case-card {
  border-radius: 4px;
}

.intro-card,
.info-card,
.case-card {
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  border: 1px solid #e8e8e8;
  position: relative;
}

.intro-card,
.info-card,
.case-card {
  padding: 16px 18px;
}

.intro-card h2,
.info-card h3,
.case-card h3 {
  margin: 0 0 8px;
  color: #222;
  font-size: 20px;
  line-height: 1.45;
  font-weight: 700;
  text-align: left;
}

.intro-card,
.info-card,
.case-card {
  text-align: left;
}

.intro-section {
  background: transparent;
  border-color: #ededed;
}

.intro-section .section-tag {
  color: #9f0b0b;
  position: relative;
  display: inline-block;
  font-size: 21px;
  letter-spacing: 0.5px;
}

.intro-section .section-tag::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -6px;
  width: 34px;
  height: 2px;
  background: rgba(179, 1, 1, 0.45);
  transform: translateX(-50%);
}

.intro-card {
  border-color: #e6e6e6;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.025);
}

.intro-card h2 {
  color: #222;
}

.intro-card h2::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 8px;
  border-radius: 50%;
  background: #d22525;
  vertical-align: middle;
}

.intro-card p {
  color: #4d4d4d;
}

.intro-content .intro-card {
  border-left: 3px solid #b30101;
  flex: 0 0 auto;
  padding: 10px 14px;
}

.intro-content .intro-card h2 {
  margin-bottom: 4px;
}

.intro-content .intro-card:nth-child(1) h2 {
  color: #9f0b0b;
}

.intro-content .intro-card:nth-child(2) h2 {
  color: #333;
}

.intro-content .intro-card:nth-child(3) h2 {
  color: #5a3d3d;
}

.audience-grid .info-card {
  background: #fbfbfb;
  border-color: #dedede;
  padding-bottom: 5px;
}

.audience-grid .info-card h3 {
  color: #fff;
  font-weight: 700;
}

.audience-grid .card-header {
  background: #d22525;
  padding: 10px 12px;
  border-radius: 4px;
  margin: -16px -18px 8px;
}

  .audience-grid .info-card::after {
  position: absolute;
  left: 18px;
  bottom: 14px;
  padding: 3px 10px;
  border: 1px solid #ead6d6;
  border-radius: 2px;
  background: #fff;
  color: #b30101;
  font-size: 11px;
  line-height: 1.4;
}

.audience-grid .divider {
  display: none;
}

.advantage-grid {
  counter-reset: advantage-card;
}

.advantage-grid .info-card {
  border: 1px solid #dedede;
  background: #d22525;
  padding: 0;
  overflow: hidden;
}

.advantage-grid .info-card::before {
  content: none;
}

.advantage-grid .card-header {
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 0;
  padding: 12px 16px;
  background: #fbfbfb;
  border: 0;
  border-bottom: 1px solid #dedede;
  box-sizing: border-box;
}

.advantage-title-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.advantage-grid .info-card h3 {
  color: #b30101;
  font-size: 18px;
  line-height: 1.45;
  font-weight: 700;
  flex: 1;
}

.advantage-grid .icon-placeholder {
  width: 32px;
  height: 32px;
  background: #fff4f4;
  border-color: rgba(179, 1, 1, 0.24);
  color: #b30101;
  border-radius: 4px;
  font-size: 13px;
  flex: 0 0 32px;
}

.advantage-no {
  color: rgba(179, 1, 1, 0.55);
  font-size: 21px;
  font-weight: 800;
  line-height: 1;
  flex: 0 0 auto;
}

.advantage-card-body {
  background: #d22525;
  padding: 16px 18px 18px;
}

.advantage-grid .info-card p {
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.8;
  font-size: 15px;
}

.faq-section {
  background: transparent;
  border-color: #eee5df;
}

.faq-section .section-tag {
  color: #8f2b12;
}

.case-card {
  background: #fffdfb;
  border-color: #eadfd8;
  border-top: 3px solid #b30101;
  display: flex;
  align-items: stretch;
  padding: 0;
  overflow: hidden;
}

.case-side-title {
  width: 46px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 8px;
  background: #fff4f1;
  border-right: 1px solid #eadfd8;
}

.case-side-title h3 {
  color: #222;
  margin: 0;
  padding: 0;
  border-bottom: none;
  font-size: 19px;
  line-height: 1.25;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0;
  writing-mode: horizontal-tb;
  text-orientation: initial;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.case-title-en {
  letter-spacing: 0;
  white-space: nowrap;
}

.case-title-en,
.case-title-char {
  display: block;
  line-height: 1.25;
}

.case-title-char {
  letter-spacing: 0;
}

.case-content {
  flex: 1;
  padding: 16px 18px;
}

.case-card strong {
  display: inline-block;
  margin-right: 4px;
  color: #b30101;
  font-size: 15px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}

.card-header .icon-placeholder {
  margin-bottom: 0;
}

.card-header h3 {
  margin: 0;
}

.divider {
  height: 1px;
  background: #ededed;
  margin: 10px 0 12px;
}

.media-placeholder {
  border: 1px solid #dedede;
  border-radius: 4px;
  background: #fafafa;
  color: #666;
}

.intro-placeholder,
.case-placeholder {
  min-height: 160px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
}

.intro-visual {
  position: relative;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.08);
}

.hotline {
  font-size: 23px;
  font-weight: 700;
  color: #b30101;
  text-align: center;
  margin-top: 0;
  padding: 6px 0;
  letter-spacing: 1px;
  background: #fffafa;
  border-radius: 4px;
  border: 1px solid rgba(179, 1, 1, 0.22);
  flex-shrink: 0;
}

.hotline a {
  color: #b30101;
  text-decoration: none;
}

.hotline a:hover {
  text-decoration: underline;
}

.intro-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  object-fit: contain;
  object-position: center top;
  border: 0;
  border-radius: 0;
  display: block;
  background: #fff;
  box-shadow: none;
  margin-top: 0;
}

.placeholder-label {
  display: inline-flex;
  align-self: flex-start;
  padding: 4px 10px;
  border-radius: 2px;
  background: #f1f1f1;
  color: #b30101;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid #e2e2e2;
}

.icon-placeholder {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ededed;
  background: #fbfbfb;
  color: #b30101;
  font-size: 20px;
  font-weight: 700;
}

.audience-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.advantage-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.case-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.case-card p + p {
  margin-top: 8px;
}

@media (max-width: 1450px) and (min-width: 1299px) {
  .section-shell {
    max-width: 1030px;
  }
}

@media (max-width: 1024px) {
  .section-shell {
    width: calc(100% - 80px);
    max-width: none;
    margin-left: auto;
    margin-right: auto;
  }

  .intro-grid,
  .advantage-grid,
  .case-grid {
    grid-template-columns: 1fr;
  }

  .intro-img {
    position: static;
    width: 100%;
    height: auto;
    max-height: none;
    min-height: 0;
  }
}

@media (max-width: 768px) {
  .finance-page {
    margin-top: 68px;
    padding-top: 18px;
  }

  .breadcrumb,
  .section-shell {
    width: auto;
    max-width: none;
    margin-left: 3%;
    margin-right: 3%;
  }

  .intro-section,
  .gallery-section,
  .faq-section {
    padding: 16px;
    border-radius: 4px;
  }

  .section-heading h2 {
    font-size: 22px;
  }

  .intro-card p,
  .info-card p,
  .case-card p {
    font-size: 15px;
    line-height: 1.75;
  }

  .intro-card,
  .info-card,
  .case-card {
    padding: 14px 16px;
  }

  .intro-placeholder,
  .case-placeholder {
    min-height: 140px;
    padding: 14px;
  }

  .intro-img {
    width: 100%;
    min-height: 0;
    height: auto;
    max-height: none;
  }

  .intro-grid,
  .audience-grid,
  .advantage-grid,
  .case-grid {
    grid-template-columns: 1fr;
  }

  .intro-content {
    height: auto;
  }

  .intro-visual {
    position: static;
    height: auto;
    overflow: visible;
  }

  .intro-content .intro-card {
    flex: 0 0 auto;
  }

  .hotline {
    margin-top: 0;
  }

  .case-card {
    display: block;
    padding: 0;
  }

  .case-side-title {
    width: auto;
    flex: none;
    justify-content: flex-start;
    padding: 10px 14px;
    border-right: none;
    border-bottom: 1px solid #eadfd8;
    background: #fff7f4;
  }

  .case-side-title h3 {
    display: block;
    letter-spacing: 0;
    font-size: 16px;
    text-align: left;
  }

  .case-title-en,
  .case-title-char {
    display: inline;
  }

  .case-content {
    padding: 14px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/caiwuzhushou.vue